module.exports = __webpack_public_path__ + "img/春节大促_10.db247374.png";